"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Menu2 = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Delete2 = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Edit2 = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Cancel2 = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _AttachFile2 = _interopRequireDefault(require("@material-ui/icons/AttachFile"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    hoverIconAttach: {
      "&:hover": {
        color: "black"
      }
    },
    hoverCancel: {
      "&:hover": {
        color: "black"
      },
      marginLeft: "auto",
      cursor: "pointer"
    }
  };
});

var MenuExpandAttachment = function MenuExpandAttachment(_ref) {
  var anchorEl = _ref.anchorEl,
      _onClose = _ref.onClose,
      attachments = _ref.attachments,
      onUpdate = _ref.onUpdate,
      onDelete = _ref.onDelete,
      onClickAttachFile = _ref.onClickAttachFile;
  var classes = useStyles();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showInput = _React$useState2[0],
      setShowInput = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      cacheFile = _React$useState4[0],
      setCacheFile = _React$useState4[1];

  React.useEffect(function () {
    setCacheFile(attachments);
  }, [attachments]);
  return /*#__PURE__*/React.createElement(_Menu2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      setShowInput(false);

      _onClose(null);
    },
    variant: "menu",
    PaperProps: {
      style: {
        backgroundColor: "rgb(243, 244, 246)"
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 480,
      paddingLeft: "1.25rem",
      paddingRight: "1.25rem",
      paddingTop: "0.875rem",
      paddingBottom: "0.875rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(_Box2["default"], {
    style: {
      display: "flex",
      backgroundColor: "rgba(229, 231, 235, 1)",
      color: "#2D7FF9",
      paddingRight: "0.5rem",
      paddingLeft: "0.5rem",
      paddingTop: "0.25rem",
      paddingBottom: "0.25rem",
      borderRadius: "0.25rem",
      cursor: "pointer"
    },
    onClick: function onClick() {
      _onClose(null);

      onClickAttachFile(true);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_AttachFile2["default"], {
    style: {
      fontSize: "1rem"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "0.875rem",
      fontWeight: 500,
      marginLeft: "0.25rem"
    }
  }, "Attach file"))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "1rem",
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
  }, cacheFile && cacheFile.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        marginRight: index % 2 == 0 ? "0.5rem" : 0,
        marginLeft: index % 2 == 0 ? 0 : "0.5rem",
        marginTop: index >= 2 ? "0.75rem" : 0,
        fontSize: "0.75rem",
        fontWeight: 500
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: 218,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid rgba(209, 213, 219,1)",
        borderRadius: "0.25rem",
        backgroundColor: "white"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url,
      alt: item.fileName,
      style: {
        maxHeight: "100%",
        maxWidth: "100%",
        objectFit: "cover"
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        color: "rgba(107, 114, 128, 1)",
        marginTop: "0.25rem"
      }
    }, showInput === index ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
      style: {
        width: "90%"
      },
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        setShowInput(-1);
        onUpdate(cacheFile);
      }
    }, /*#__PURE__*/React.createElement(_InputBase2["default"], {
      fullWidth: true,
      value: cacheFile[index].fileName,
      onChange: function onChange(e) {
        var oldCache = _toConsumableArray(cacheFile);

        oldCache[index].fileName = e.target.value;
        setCacheFile(oldCache);
      },
      style: {
        border: "2px solid rgba(209, 213, 219,1)",
        borderRadius: "0.25rem",
        paddingLeft: "0.25rem",
        paddingRight: "0.25rem",
        fontSize: "0.8rem",
        backgroundColor: "white"
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        width: "10%",
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(_Box2["default"], {
      className: classes.hoverCancel,
      style: {
        cursor: "pointer",
        marginLeft: "auto"
      },
      onClick: function onClick() {
        return setShowInput(-1);
      }
    }, /*#__PURE__*/React.createElement(_Cancel2["default"], {
      fontSize: "small"
    })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, item.fileName.length > 17 ? item.fileName.slice(0, 17).trim() + "..." : item.fileName), /*#__PURE__*/React.createElement(_Box2["default"], {
      className: classes.hoverIconAttach,
      style: {
        marginLeft: "auto",
        cursor: "pointer"
      },
      onClick: function onClick() {
        setShowInput(index);
      }
    }, /*#__PURE__*/React.createElement(_Edit2["default"], {
      style: {
        fontSize: "1rem"
      }
    })), /*#__PURE__*/React.createElement(_Box2["default"], {
      className: classes.hoverIconAttach,
      style: {
        marginLeft: "0.25rem",
        cursor: "pointer"
      },
      onClick: function onClick(e) {
        onDelete(cacheFile, index);
        var filterAttach = cacheFile.filter(function (val, i) {
          return i !== index;
        });
        setCacheFile(filterAttach);
      }
    }, /*#__PURE__*/React.createElement(_Delete2["default"], {
      style: {
        fontSize: "1rem"
      }
    })))));
  }))));
};

MenuExpandAttachment.propTypes = {
  anchorEl: _propTypes["default"].any,
  onClose: _propTypes["default"].func,
  attachments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    fileName: _propTypes["default"].string
  })),
  onDelete: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onClickAttachFile: _propTypes["default"].func
};
var _default = MenuExpandAttachment;
exports["default"] = _default;